// import './App.css';
import { ThemeProvider } from "./Contexts/ThemeContext";
import "./index.css";
import Article from "./Pages/Article/Article";
import Cryptocurrency from "./Pages/Cryptocurrency/Cryptocurrency";
import Home from "./Pages/Home/Home";
import AboutUs from "./Pages/AboutUs/AboutUs";
import TechTV from "./Pages/TechTV/Tech";
import { BrowserRouter as Router, Route, Routes } from "react-router";
import Reviewer from "./Pages/Reviewer/Reviewer";
import ReviewerII from "./Pages/Reviewer/ReviewerII/ReviewerII";
import ReviewerIII from "./Pages/Reviewer/ReviewerIII/ReviewerIII";
import ForgetPage from "./Pages/Reviewer/ForgetPage/ForgetPage";
import WriterLogin from "./Pages/Writer/WriterLogin/WriterLogins";
import WriterActicle from "./Pages/Writer/WriterActicle/WriterActicles";
import PublisherLogin from "./Pages/Publisherpage/PublisherLogin";
import Previewpage from "./Pages/Publisherpage/Previewpage/Previewpage";
import PublishReview from "./ComponentDash/Publisherpages/PublishReview/PublishReview";
import Admin from "./Pages/Admain/Admin";
import NotFound from "./Pages/NotFound/NotFound";
import AdminBoard from "./Pages/Admain/AdminBoard/AdminBoard";
import AdminEmploy from "./Pages/Admain/AdminEmploy/AdminEmploy";
import AdminEdit from "./Pages/Admain/AdminEdit/AdminEdit";
import AccessCode from "./Pages/Admain/AccessCode/AccessCode";
import News from "./Components/News/News";
import Events from "./Pages/Events/events.jsx";
import DynamicPage from "./Pages/Dynamic/DynamicPage";
import PostDetail from "./Pages/PostDetail/PostDetail";
import DynamicPageii from "./Pages/DynamicII/DynamicPageii";
import Old from "./Components/News/old/old.jsx";
import Construction from "./Pages/construction/Construction.jsx";

function App() {
  return (
    <ThemeProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="*" element={<Construction />} />
            <Route path="/" element={<Home />} />

            {/* <Route path="/" element={<DynamicPage />} /> */}
            <Route path="/page/:number" element={<DynamicPageii />} />
            <Route path="/post/:id" element={<PostDetail />} />
            <Route path="/news/:id" element={<News />} />
            {/* <Route path="/article/" element={<Old />} /> */}
            <Route path="/:id" element={<Old />} />
            <Route path="/events" element={<Events />} />
            <Route path="/category/:category" element={<Cryptocurrency />} />
            {/* <Route path="/category/" element={<Cryptocurrency />} /> */}
            <Route path="/about" element={<AboutUs />} />
            <Route path="/TechTV" element={<TechTV />} />
            <Route path="/Reviewer" element={<Reviewer />} />
            <Route path="/ReviewerII" element={<ReviewerII />} />
            <Route path="/ReviewerII/ReviewerIII" element={<ReviewerIII />} />
            <Route path="/Reviewer/ForgetPage" element={<ForgetPage />} />
            <Route path="/WriterLogin" element={<WriterLogin />} />
            <Route
              path="/WriterLogin/WriterActicle"
              element={<WriterActicle />}
            />
            <Route path="/PublisherLogin" element={<PublisherLogin />} />
            <Route
              path="/PublisherLogin/Previewpage"
              element={<Previewpage />}
            />
            <Route path="/Admin" element={<Admin />} />
            <Route path="/Admin/AdminBoard" element={<AdminBoard />} />
            <Route
              path="/Admin/AdminBoard/AdminEmploy"
              element={<AdminEmploy />}
            />
            <Route
              path="/Admin/AdminBoard/AdminEmploy/AdminEdit"
              element={<AdminEdit />}
            />
            <Route
              path="/Admin/AdminBoard/AccessCode"
              element={<AccessCode />}
            />
            <Route
              path="/PublisherLogin/Previewpage/PublishReview/:Spot"
              element={<PublishReview />}
            />

            <Route path="*" element={<NotFound />} />
          </Routes>
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App;
